/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfixstep13Inputs */

const en_crosspostinghelpfixstep13 = /** @type {(inputs: Crosspostinghelpfixstep13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Facebook, open Settings → Business Integrations and remove our connection service "bundle.social" – this clears an old, incomplete authorization.`)
};

const de_crosspostinghelpfixstep13 = /** @type {(inputs: Crosspostinghelpfixstep13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Facebook öffnen: Einstellungen → Geschäftsintegrationen und unseren Verbindungsdienst „bundle.social“ entfernen – das löscht eine alte, unvollständige Freigabe.`)
};

/**
* | output |
* | --- |
* | "In Facebook, open Settings → Business Integrations and remove our connection service \"bundle.social\" – this clears an old, incomplete authorization." |
*
* @param {Crosspostinghelpfixstep13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfixstep13 = /** @type {((inputs?: Crosspostinghelpfixstep13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfixstep13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfixstep13(inputs)
	return de_crosspostinghelpfixstep13(inputs)
});
export { crosspostinghelpfixstep13 as "crosspostingHelpFixStep1" }